import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class LogService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

  constructor(private http:Http) { }

  getLogs(begindate, enddate, user:string, page) {

    var filter = {
      Usuario: user,
      DataInicio: begindate,
      DataFim: enddate
    };

    const skip = page * globalConst.paginationSkip;

    return this.http
      .post(this.apiUrl + "logs/v1/logs?$orderby=DataCriacao desc&$top=" + globalConst.paginationSkip + "&$skip=" + skip, filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/log/service/log-list/log.service.ts